import logo from "./logo.svg";
import "./App.css";
import ComingSoon from "./components/ComingSoon";

function App() {
  return (
    <div className="App">
      <ComingSoon />
    </div>
  );
}

export default App;
